import { pricingDetailOf } from '@/components/CorporateUsers/Carriers/utils';

export const TARIFF_SOURCES = {
    OWN: 'OWN',
    DEFAULT: 'DEFAULT',
    NONE: 'NONE',
};

// Must agree with the Carriers tab's pricing card: a shipper's own carrier rate replaces the org default.
export const shipperTariffLinksFor = (shipperGroups, defaultPricing) => {
    const hasDefault = defaultPricing.pricingKeys.length > 0;

    return shipperGroups.reduce((links, group) => {
        for (const shipper of group.shippers) {
            const link = {
                client_id: shipper.client_id,
                business_name: shipper.business_name,
                profileNames: shipper.profileNames,
                onMap: shipper.onMap,
            };
            const hasOwnPricing = shipper.pricingKeys.length > 0;

            if (hasOwnPricing) {
                const ownDetail = pricingDetailOf(shipper);
                links.push({ ...link, source: TARIFF_SOURCES.OWN, detail: ownDetail });
                continue;
            }
            if (hasDefault) {
                const defaultDetail = pricingDetailOf(defaultPricing);
                links.push({ ...link, source: TARIFF_SOURCES.DEFAULT, detail: `Default: ${defaultDetail}` });
                continue;
            }

            links.push({
                ...link,
                source: TARIFF_SOURCES.NONE,
                detail: "No tariff linked; rates on the carrier's marketplace rate, if it has one",
            });
        }

        return links;
    }, []);
};
